module.exports = __webpack_public_path__ + "img/cat-space.dedd6525.svg";